import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { virtualBackgroundActivationFailed } from 'features/virtual-backgrounds/virtualBackgroundsSlice';

export function* virtualBackgroundNotAppliedEventSaga(
  action: ReturnType<typeof virtualBackgroundActivationFailed>
) {
  const { reason, requested } = action.payload;

  // A failed reset carries no request: that is "could not remove", not "asked for and dropped".
  if (!requested) {
    return;
  }

  yield call(eventBus.virtualBackgroundNotApplied, requested, reason);
}
